import { all, put, select, takeLatest } from 'redux-saga/effects';
import { push as routerPush } from 'react-router-redux';
import { apiSaga } from '../../../sagas';
import { contracting as conApi, workspace as wpApi, partner as partnerApi } from '../../../api';
import * as cnt from './constants.js';
import * as wkspConst from '../../workspace/store/constants';
import {
  UPDATE_PROPS,
  RESET_TEMPLATE_SELECTION,
  RESET_LOCATION_SELECTION,
} from '../../../stores/contracting/supplier-wizard/constants';
import { POPULATE_REDUCER } from '../../../stores/contracting/small-template-list/small-template-list-constants';

const getRoute = state => state.routing.locationBeforeTransitions.pathname;
const getTaxId = state => state.profile.get('corporateIdentifier');

// de-select the selected template
function* resetSelectedTemplate() {
  yield put({
    type: UPDATE_PROPS,
    payload: {
      templateSelected: {},
    },
  });
}

// de-select the selected location
function* resetSelectedLocation() {
  yield put({
    type: RESET_LOCATION_SELECTION,
    payload: {
      locationId: '',
    },
  });
}

function* resetRateSelections() {
  yield put({
    type: RESET_TEMPLATE_SELECTION,
  });
}

function* resetContractRequest() {
  // get the default taxId from partner info
  const taxId = yield select(getTaxId);
  yield put({ type: 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD', payload: { taxId } });
}

function* sendRates(payload) {
  yield* apiSaga(cnt.SEND_RATES, conApi.sendContract, [payload]);
}

function* sendRateRequest(payload) {
  yield* apiSaga(cnt.SEND_RATE_REQUESTS, conApi.sendContractRequest, [payload]);
}

function* sendMessage({ payload: { partnerId, channel, message } }) {
  yield* apiSaga(cnt.SEND_MESSAGE, wpApi.newMessage, [{
    type: channel === 'notes' ? 'note' : 'message',
    ...message,
    partnerIds: [partnerId],
  }]);
}

function* getPartnerDetails({ payload: { pathname } }) {
  if (pathname.split('/')[1] === 'partnerDetails') {
    const partnerId = pathname.split('/')[2];
    yield put({ type: cnt.CLEAR_STORE });

    yield all([
      apiSaga(cnt.GET_PARTNER_INFO, partnerApi.getCompanyInfo, [{ partnerId }]),
      _getFiles(partnerId),
      _getActivities(partnerId),
    ]);
  }
}

function* refreshActivities() {
  const pathname = yield select(getRoute);
  if (pathname.split('/')[1] === 'partnerDetails') {
    const companyId = pathname.split('/')[2];
    yield* apiSaga(cnt.GET_ACTIVITY, partnerApi.getActivities, [{ assetId: companyId }]);
  }
}

function* _getActivities(partnerId) {
  yield* apiSaga(cnt.GET_ACTIVITY, partnerApi.getActivities, [{ assetId: partnerId }]);
}

function* _getFiles(partnerId) {
  yield* apiSaga(cnt.GET_FILES, conApi.getContracts, [{
    query: { partnerIds: partnerId },
    includeTemplateNames: true,
  }]);
}

function* refreshFiles() {
  const pathname = yield select(getRoute);
  if (pathname.split('/')[1] === 'partnerDetails') {
    const partnerId = pathname.split('/')[2];
    yield all([
      _getFiles(partnerId),
      _getActivities(partnerId),
    ]);
  }
}

function* contractFromHistoryFeed({ type, payload }) {
  yield apiSaga(type, conApi.contractFromHF, [payload]);
}

function* contractFromHistoryFeedSuccess({ payload }) {
  yield put(routerPush(payload.path.replace('#contractId#', payload.contractId)));
}

function* markAsRead() { // markgin all conversation as read (general an contracting)
  const pathname = yield select(getRoute);
  if (pathname.split('/')[1] === 'partnerDetails') {
    const partnerId = pathname.split('/')[2];
    yield apiSaga(
      wkspConst.CONVERSATIONS_READ,
      wpApi.conversationsRead,
      [{ assetId: partnerId, assetType: 'partner' }],
    );
  }
}

export default [
  takeLatest('@@router/LOCATION_CHANGE', getPartnerDetails),
  takeLatest(cnt.RESET_SELECTED_ALL, resetRateSelections),
  takeLatest(cnt.RESET_SELECTED_LOCATION, resetSelectedLocation),
  takeLatest(cnt.RESET_SELECTED_RATE, resetSelectedTemplate),
  takeLatest(cnt.RESET_CONTRACTING_REQUEST, resetContractRequest),
  takeLatest(cnt.SEND_MESSAGE, sendMessage),
  takeLatest(cnt.SEND_RATES, sendRates),
  takeLatest(cnt.SEND_RATE_REQUESTS, sendRateRequest),
  takeLatest(POPULATE_REDUCER, resetSelectedTemplate),
  takeLatest(`${cnt.SEND_MESSAGE}_SUCCESS`, refreshActivities),
  takeLatest(`${cnt.SEND_RATES}_SUCCESS`, refreshFiles),
  takeLatest(`${cnt.SEND_RATES}_SUCCESS`, refreshActivities),
  takeLatest(`${cnt.SEND_RATE_REQUESTS}_SUCCESS`, refreshFiles),
  takeLatest(`${cnt.SEND_RATE_REQUESTS}_SUCCESS`, refreshActivities),
  takeLatest('CONTRACT_FROM_HF', contractFromHistoryFeed),
  takeLatest('CONTRACT_FROM_HF_SUCCESS', contractFromHistoryFeedSuccess),
  takeLatest(`${cnt.GET_ACTIVITY}_SUCCESS`, markAsRead),
];



// WEBPACK FOOTER //
// ./src/app/components/partner-details/__store__/sagas.js